import useCases from '@/hooks/useCases';
import { formatDate } from '@/utils/dates';
import { Box, Card, CardContent, Popper } from '@mui/material';
import { observer } from 'mobx-react';
import { FC } from 'react';
import CaseDataBarItem from './CaseDataBarItem';
import { CaseDataBarLocationItem } from './CaseDataBarLocationItem';
import { CaseFlagReason } from './CaseFlagReason';

interface ICaseDataBarPopoverProps {
  anchorEl: HTMLElement | null;
}

export const CaseDataBarPopover: FC<ICaseDataBarPopoverProps> = observer(({ anchorEl }) => {
  const cases = useCases();

  return (
    <Popper open={!!anchorEl} anchorEl={anchorEl} placement="bottom-end">
      <Card
        sx={{
          mt: 1,
          maxWidth: '400px',
          maxHeight: '80vh',
          overflow: 'auto',
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            padding: 2,
          }}
        >
          {cases.isFlagged() && (
            <Box>
              <CaseFlagReason urgent={cases.urgent} />
            </Box>
          )}
          {cases.caseId && (
            <CaseDataBarItem title="Dato" value={formatDate(cases.createdAt)} showText />
          )}
          {cases.cpr && (
            <>
              <CaseDataBarItem title="Navn" value={cases.patientName} />
              <CaseDataBarItem title="CPR" value={`#${cases.cpr}`} />
            </>
          )}
          {!cases.cpr && cases.patientId && (
            <CaseDataBarItem
              title="Patient ID"
              value={cases.patientId}
              operation="OpenPatient"
              linkTo={cases.patientId}
            />
          )}
          {cases.caseId && <CaseDataBarItem title="Corti ID" value={cases.caseId} showText />}
          {cases.externalId && (
            <CaseDataBarItem title="Journal ID" value={cases.externalId} showText />
          )}
          {cases.caseId && <CaseDataBarLocationItem />}
        </CardContent>
      </Card>
    </Popper>
  );
});
